import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons/WhatsAppIcon";

const SOCIAL_AUTO = {
  instagram: "https://www.instagram.com/nsamotors_auto?igsh=bjRvdmNjaXN4c2Fq",
  facebook: "https://www.facebook.com/share/1ENvb3LXnj/?mibextid=wwXIfr",
};
const SOCIAL_MOTO = {
  instagram: "https://www.instagram.com/nsamotors_2ruote?igsh=MWQ1bzdieHB4aXF3NA==",
  facebook: "https://www.facebook.com/share/1BWsfTDp7f/?mibextid=wwXIfr",
};

const LINKS_AUTO = [
  { to: "/auto", label: "Autosalone" },
  { to: "/auto/servizi", label: "Servizi" },
  { to: "/auto/officina", label: "Officina" },
  { to: "/lavora-con-noi", label: "Lavora con noi" },
];
const LINKS_MOTO = [
  { to: "/moto/ktm", label: "KTM" },
  { to: "/moto/husqvarna", label: "Husqvarna" },
  { to: "/moto/gasgas", label: "GasGas Trial" },
  { to: "/moto/officina", label: "Officina" },
  { to: "/moto/racing-team", label: "Racing Team" },
  { to: "/lavora-con-noi", label: "Lavora con noi" },
];
const LINKS_GENERAL = [
  { to: "/auto", label: "Auto" },
  { to: "/moto", label: "Moto" },
  { to: "/moto/racing-team", label: "Racing Team" },
  { to: "/lavora-con-noi", label: "Lavora con noi" },
  { to: "/contatti", label: "Contatti" },
];

export default function Footer() {
  const path = useLocation().pathname;
  const world = path.startsWith("/auto") ? "auto" : path.startsWith("/moto") ? "moto" : "general";

  const description =
    world === "auto"
      ? "Concessionaria e officina auto multimarca. Vendita nuovo e usato, noleggio, permuta, assistenza specializzata e servizi post-vendita."
      : world === "moto"
      ? "Dealer Ufficiale KTM, Husqvarna e Gas Gas Trial per Bergamo e provincia. Vendita, ricambi, officina moto e Racing Team dedicato."
      : "Dealer Ufficiale KTM, Husqvarna e Gas Gas Trial per Bergamo e provincia. Concessionaria e officina auto multimarca — vendita, noleggio, usato.";

  const links = world === "auto" ? LINKS_AUTO : world === "moto" ? LINKS_MOTO : LINKS_GENERAL;
  const socials = world === "auto" ? SOCIAL_AUTO : world === "moto" ? SOCIAL_MOTO : null;

  return (
    <footer className="bg-gray-900 text-white mt-24" data-testid="footer">
      <div className="nsa-container py-20 md:py-24 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src="/logos/nsa-motors-white.png" alt="NSA Motors" className="h-14 md:h-16 w-auto" />
          <p className="mt-6 max-w-md text-white/70 font-body leading-relaxed">{description}</p>

          {socials && (
            <div className="mt-6">
              <div className="label-eyebrow text-white/50 mb-3">Seguici sui nostri social</div>
              <div className="flex items-center gap-4">
                <a href={socials.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram NSA Motors" className="hover:text-[color:var(--nsa-orange)]">
                  <Instagram size={22} />
                </a>
                <a href={socials.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook NSA Motors" className="hover:text-[color:var(--nsa-orange)]">
                  <Facebook size={22} />
                </a>
              </div>
            </div>
          )}
        </div>

        <div>
          <div className="label-eyebrow text-white/50 mb-4">
            {world === "auto" ? "Reparto Auto" : world === "moto" ? "Reparto Moto" : "Mondo"}
          </div>
          <ul className="space-y-2 font-body">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[color:var(--nsa-orange)]">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="label-eyebrow text-white/50 mb-4">Contatti</div>
          <ul className="space-y-3 font-body text-white/85">
            <li className="flex items-start gap-2">
              <MapPin size={16} className="mt-1 text-[color:var(--nsa-orange)] shrink-0" />
              Via Serio 87, 24020 Casnigo (BG)
            </li>
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-1 text-[color:var(--nsa-orange)] shrink-0" />
              <a href="tel:+390350276966" className="hover:text-[color:var(--nsa-orange)]">+39 035 027 6966</a>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1 text-[color:var(--nsa-orange)] shrink-0"><WhatsAppIcon size={16} /></span>
              <a href="https://wa.me/393494062553" target="_blank" rel="noopener noreferrer" className="hover:text-[color:var(--nsa-orange)]">+39 349 406 2553</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={16} className="mt-1 text-[color:var(--nsa-orange)] shrink-0" />
              <a href="mailto:info@nsamotors.eu" className="hover:text-[color:var(--nsa-orange)]">info@nsamotors.eu</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="nsa-container py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <span>© {new Date().getFullYear()} NSA Motors — Tutti i diritti riservati</span>
          <span>Cinematic bold · Made with passion</span>
        </div>
      </div>
    </footer>
  );
}
